/* eslint-disable react/prop-types */
import React from 'react';
// @ts-ignore - React 18 types issue with react-dom/client
import { createRoot } from 'react-dom/client';
import 'normalize.css';
import './index.css';
import GlobalFonts from './components/abstracts/fonts';
import { configureEnvironment } from './env';
import process from "process";
import { Buffer } from "buffer";
(window as any).Buffer = Buffer;
(window as any).process = process;

const CommonWrapper: React.FC<React.PropsWithChildren> = (props) => (
  <div>
    <GlobalFonts />
    {props.children}
  </div>
);

const container = document.getElementById('root');
const root = createRoot(container!);

void configureEnvironment()
  .then(async () => {
    const Root = (await import('./Root')).default;
    const { setupDB } = await import('./service/upload/indexedDb');
    setupDB();
    const { setRedirectURL } = await import('./util/urlRedirect');
    const currentURL = window.location.pathname + window.location.search + window.location.hash;
    setRedirectURL(currentURL);
    return <Root />;
  })
  .catch((error) => {
    console.error('Application initialization failed:', error);
    return <div>
      <h1>Application failed to load</h1>
      <p>Error: {error?.message || String(error)}</p>
      <p>Check the browser console for more details</p>
    </div>;
  })
  .then((it) => {
    root.render(<CommonWrapper>{it}</CommonWrapper>);
  });
